/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MoonLoader } from "react-spinners";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { format } from "date-fns";
import { toastEmmit } from "../../../../Helper/Toastr";

export default function AffiliateUserDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [affiliate, setAffiliate] = useState(null);
  const [loading, setLoading] = useState(true);

  const [actionLoading, setActionLoading] = useState(false);

  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (id) {
      getAffiliateDetails();
    }
  }, [id]);

  // ---------------------------------------------------
  // GET AFFILIATE DETAILS
  // ---------------------------------------------------

  const getAffiliateDetails = async () => {
    try {
      setLoading(true);

      const res = await GetService(
        `${API_URL.GET_ALL_AFFILIATE_USERS_DETAILS}/${id}`,
      );

      if (res?.data?.status) {
        const data = res.data.data;

        setAffiliate({
          ...data,
          promotionMethods: data?.promotionMethods
            ? JSON.parse(data.promotionMethods)
            : [],
          socialLinks: data?.socialLinks ? JSON.parse(data.socialLinks) : {},
        });
      } else {
        showErrorAlert(
          res?.data?.message || "Unable to fetch affiliate details.",
        );
      }
    } catch (error) {
      showErrorAlert(error?.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------
  // APPROVE AFFILIATE
  // ---------------------------------------------------

  function handleApprove() {
    showConfirmation(
      "Approve Affiliate",
      "Are you sure you want to approve this affiliate application?",
      "",
      "Approve",
      "Cancel",
      () => {
        setActionLoading(true);

        PostService(`${API_URL.UPDATE_AFFILIATE_STATUS}/${id}`, {
          status: "approved",
        }).then(
          async (res) => {
            if (res?.data?.status) {
              await getAffiliateDetails();

              showSuccessAlert(
                res?.data?.message || "Affiliate approved successfully.",
              );
            } else {
              showErrorAlert(
                res?.data?.message || "Failed to approve affiliate.",
              );
            }

            setActionLoading(false);
          },
          (err) => {
            showErrorAlert(
              err?.response?.data?.message ||
                err?.data?.message ||
                "Something went wrong while approving affiliate.",
            );

            setActionLoading(false);
          },
        );
      },
      () => {
        setActionLoading(false);
      },
    );
  }

  // ---------------------------------------------------
  // REJECT AFFILIATE
  // ---------------------------------------------------

  const handleReject = async () => {
    if (!rejectReason.trim()) {
      return;
    }

    setActionLoading(true);

    try {
      const payload = {
        rejectionReason: rejectReason.trim(),
        status: "rejected",
      };

      const res = await PostService(
        `${API_URL.UPDATE_AFFILIATE_STATUS}/${id}`,
        payload,
      );

      console.log("Reject affiliate response:", res);

      if (res?.data?.status === true) {
        setShowRejectModal(false);
        setRejectReason("");
        toastEmmit(
          res?.data?.message || "Affiliate application rejected.",
          "success",
        );

        await getAffiliateDetails();
      } else {
        toastEmmit(
          res?.data?.message || "Failed to reject affiliate.",
          "error",
        );
      }
    } catch (error) {
      console.error("Reject error:", error);

      toastEmmit(
        error?.data?.message ||
          error?.response?.data?.message ||
          "Something went wrong while rejecting affiliate.",
        "error",
      );
    } finally {
      setActionLoading(false);
    }
  };

  // ---------------------------------------------------
  // COPY REFERRAL LINK
  // ---------------------------------------------------

  const copyReferralLink = async () => {
    if (!affiliate?.affiliateLink) {
      return;
    }

    try {
      await navigator.clipboard.writeText(affiliate.affiliateLink);

      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  // ---------------------------------------------------
  // STATUS BADGE
  // ---------------------------------------------------

  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return <span className="badge badge-success px-3 py-2">Approved</span>;

      case "rejected":
        return <span className="badge badge-danger px-3 py-2">Rejected</span>;

      default:
        return (
          <span className="badge badge-warning px-3 py-2">Pending Review</span>
        );
    }
  };

  const getvaluesMethods = (methods) => {
    if (!methods) return "-";

    if (Array.isArray(methods)) {
      return methods.join(", ");
    }

    try {
      return JSON.parse(methods).join(", ");
    } catch {
      return methods
        .split(",")
        .map((item) => item.trim())
        .join(", ");
    }
  };

  // ---------------------------------------------------
  // VALUE HELPER
  // ---------------------------------------------------

  const value = (data) => {
    if (data === null || data === undefined || data === "") {
      return "-";
    }

    return data;
  };

  // ---------------------------------------------------
  // LOADING
  // ---------------------------------------------------

  if (loading) {
    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h3>Affiliate Details</h3>
              </div>
            </div>
          </div>
        </section>

        <div className="LoaderSpinner">
          <MoonLoader
            color={"#003bff"}
            loading={loading}
            speedMultiplier={0.6}
            size={50}
          />
          <div>Loading... Please wait.</div>
        </div>
      </>
    );
  }

  // ---------------------------------------------------
  // NO DATA
  // ---------------------------------------------------

  if (!affiliate) {
    return (
      <>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h3>Affiliate Details</h3>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body text-center py-5">
                <h5>Affiliate not found</h5>

                <button
                  type="button"
                  className="btn btn-primary mt-3"
                  onClick={() => navigate("/panel/affiliate-user")}
                >
                  Back to Affiliate Users
                </button>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }

  return (
    <>
      {/* =====================================================
          PAGE HEADER
      ====================================================== */}

      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Affiliate Details</h3>
            </div>

            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>

                <Link
                  to="/panel/affiliate-user"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Affiliate Users
                </Link>

                <li className="breadcrumb-item active">Details</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          MAIN CONTENT
      ====================================================== */}

      <section className="content">
        <div className="container-fluid">
          {/* =================================================
              TOP SUMMARY CARD
          ================================================== */}

          <div className="card card-primary card-outline shadow-sm mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-lg-8">
                  <div className="media">
                    <div
                      className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3"
                      style={{
                        width: 60,
                        height: 60,
                        fontSize: 25,
                        fontWeight: 500,
                      }}
                    >
                      {affiliate?.firstName?.charAt(0)?.toUpperCase()}
                    </div>

                    <div className="media-body">
                      <h3 className="mb-1">
                        {affiliate?.firstName} {affiliate?.lastName}
                      </h3>

                      <p className="text-muted mb-1">
                        <i className="fas fa-envelope mr-2"></i>
                        {affiliate?.email}
                      </p>

                      <p className="text-muted mb-2">
                        <i className="fas fa-phone mr-2"></i>
                        {affiliate?.phone}
                      </p>

                      {getStatusBadge(affiliate?.status)}
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 text-lg-right mt-3 mt-lg-0">
                  {affiliate?.status === "pending" && (
                    <>
                      <button
                        className="btn btn-sm btn-success mr-2"
                        disabled={actionLoading}
                        onClick={handleApprove}
                      >
                        {actionLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm mr-2"></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-check mr-2"></i>
                            Approve
                          </>
                        )}
                      </button>

                      <button
                        className="btn btn-sm btn-danger"
                        disabled={actionLoading}
                        onClick={() => setShowRejectModal(true)}
                      >
                        <i className="fas fa-times mr-2"></i>
                        Reject
                      </button>
                    </>
                  )}

                  {affiliate?.status === "approved" && (
                    <div className="alert alert-success mb-0">
                      <i className="fas fa-check-circle mr-2"></i>
                      This affiliate has been approved.
                    </div>
                  )}

                  {affiliate?.status === "rejected" && (
                    <div className="alert alert-danger mb-0">
                      <i className="fas fa-times-circle mr-2"></i>
                      This application was rejected.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* =================================================
              PERSONAL INFORMATION
          ================================================== */}

          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-user mr-2"></i>
                Personal Information
              </h3>
            </div>

            <div className="card-body">
              <div className="row">
                <InfoItem
                  label="First Name"
                  value={value(affiliate?.firstName)}
                />

                <InfoItem
                  label="Last Name"
                  value={value(affiliate?.lastName)}
                />

                <InfoItem
                  label="Email Address"
                  value={value(affiliate?.email)}
                />

                <InfoItem
                  label="Mobile Number"
                  value={value(affiliate?.phone)}
                />

                <InfoItem
                  label="Date of Birth"
                  value={affiliate?.dateOfBirth}
                />

                <InfoItem
                  label="Application Date"
                  value={
                    affiliate?.createdAt
                      ? format(new Date(affiliate?.createdAt), "dd/MM/yyyy")
                      : "-"
                  }
                />
              </div>
            </div>
          </div>

          {/* =================================================
              BUSINESS INFORMATION
          ================================================== */}

          {
            <div className="card mb-4">
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-building mr-2"></i>
                  Business Information
                </h3>
              </div>

              <div className="card-body">
                <div className="row">
                  <InfoItem
                    label="Affiliate Type"
                    value={affiliate?.affiliateType}
                  />

                  <InfoItem
                    label="Business Name"
                    value={value(affiliate?.businessName || "-")}
                  />

                  <InfoItem
                    label="Website"
                    value={
                      affiliate?.website ? (
                        <a
                          href={affiliate.website}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {affiliate.website}
                        </a>
                      ) : (
                        "-"
                      )
                    }
                  />
                </div>
              </div>
            </div>
          }

          {/* =================================================
              ADDRESS
          ================================================== */}

          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-map-marker-alt mr-2"></i>
                Address Information
              </h3>
            </div>

            <div className="card-body">
              <div className="row">
                <InfoItem
                  label="Street Address"
                  value={value(affiliate?.streetAddress)}
                  fullWidth
                />

                <InfoItem label="City" value={value(affiliate?.city)} />

                <InfoItem
                  label="State / Province"
                  value={value(affiliate?.state)}
                />

                <InfoItem
                  label="ZIP / Postal Code"
                  value={value(affiliate?.zipCode)}
                />

                <InfoItem label="Country" value={value(affiliate?.country)} />
              </div>
            </div>
          </div>

          {/* =================================================
              PROMOTIONAL INFORMATION
          ================================================== */}

          {(affiliate?.promotion_channel ||
            affiliate?.promotional_method ||
            affiliate?.audience_details ||
            affiliate?.reason) && (
            <div className="card mb-4">
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-bullhorn mr-2"></i>
                  Promotional Information
                </h3>
              </div>

              <div className="card-body">
                <div className="row">
                  <InfoItem
                    label="Promotional Method"
                    value={getvaluesMethods(affiliate?.promotionMethods)}
                    fullWidth
                  />

                  <InfoItem
                    label="Audience Size"
                    value={value(affiliate?.audienceSize)}
                    fullWidth
                  />

                  <InfoItem
                    label="Why do you want to become an affiliate?"
                    value={value(affiliate?.reason)}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          )}

          {/* =================================================
              PAYMENT INFORMATION
          ================================================== */}

          <div className="card mb-4">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-credit-card mr-2"></i>
                Payment Information
              </h3>
            </div>

            <div className="card-body">
              <div className="row">
                <InfoItem
                  label="Payment Method"
                  value={value(affiliate?.paymentMethod)}
                />

                {affiliate?.paymentMethod === "paypal" && (
                  <>
                    <InfoItem
                      label="PayPal Email"
                      value={value(affiliate?.paypalEmail)}
                    />
                  </>
                )}

                {affiliate?.paymentMethod === "bank_transfer" && (
                  <>
                    <InfoItem
                      label="Account Holder Name"
                      value={value(affiliate?.accountHolderName)}
                    />

                    <InfoItem
                      label="Bank Name"
                      value={value(affiliate?.bankName)}
                    />

                    <InfoItem
                      label="Account Number"
                      value={value(affiliate?.accountNumber)}
                    />

                    <InfoItem
                      label="Routing Number"
                      value={value(affiliate?.routingNumber)}
                    />

                    <InfoItem
                      label="SWIFT / BIC"
                      value={value(affiliate?.swiftCode)}
                    />

                    <InfoItem label="IBAN" value={value(affiliate?.iban)} />
                  </>
                )}
              </div>
            </div>
          </div>

          {/* =================================================
              AFFILIATE INFORMATION
          ================================================== */}

          {affiliate?.status === "approved" && (
            <div className="card card-success card-outline mb-4">
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-link mr-2"></i>
                  Affiliate Information
                </h3>
              </div>

              <div className="card-body">
                <div className="row">
                  <InfoItem
                    label="Affiliate Code"
                    value={value(affiliate?.affiliateCode)}
                  />

                  <InfoItem
                    label="Promo Code (For users to get 10% off)"
                    value={value(affiliate?.promoCode || "-")}
                  />

                  <div className="col-md-12 mt-3">
                    <label className="font-weight-bold">
                      Affiliate Referral Link
                    </label>

                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        value={affiliate?.affiliateLink || ""}
                        readOnly
                      />

                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={copyReferralLink}
                        >
                          <i className="fas fa-copy mr-1"></i>

                          {copied ? "Copied" : "Copy Link"}
                        </button>
                      </div>
                    </div>

                    <small className="text-muted">
                      This is the referral link generated for the affiliate.
                    </small>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* =================================================
              REJECTION INFORMATION
          ================================================== */}

          {affiliate?.status === "rejected" && affiliate?.rejectionReason && (
            <div className="card card-danger card-outline mb-4">
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-times-circle mr-2"></i>
                  Rejection Information
                </h3>
              </div>

              <div className="card-body">
                <label className="font-weight-bold">Rejection Reason</label>

                <div className="alert alert-danger mb-0">
                  {affiliate.rejectionReason}
                </div>
              </div>
            </div>
          )}

          {/* =================================================
              BOTTOM ACTION
          ================================================== */}

          {affiliate?.status === "pending" && (
            <div className="card">
              <div className="card-body">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={() => navigate("/panel/affiliate-user")}
                >
                  <i className="fas fa-arrow-left mr-1"></i>
                  Back to Affiliate Users
                </button>

                <div className="float-right">
                  <button
                    type="button"
                    className="btn btn-sm btn-success mr-2"
                    disabled={actionLoading}
                    onClick={handleApprove}
                  >
                    <i className="fas fa-check mr-1"></i>
                    Approve Affiliate
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    disabled={actionLoading}
                    onClick={() => setShowRejectModal(true)}
                  >
                    <i className="fas fa-times mr-1"></i>
                    Reject
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* =====================================================
          REJECT MODAL
      ====================================================== */}

      {showRejectModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject Affiliate Application</h5>

                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setShowRejectModal(false);
                    setRejectReason("");
                  }}
                >
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <p className="text-muted">
                  Please provide a reason for rejecting this affiliate
                  application.
                </p>

                <label className="font-weight-bold">
                  Rejection Reason <span className="text-danger">*</span>
                </label>

                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Enter rejection reason..."
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                />

                {!rejectReason.trim() && (
                  <small className="text-danger">
                    Rejection reason is required.
                  </small>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  disabled={actionLoading}
                  onClick={() => {
                    setShowRejectModal(false);
                    setRejectReason("");
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  disabled={actionLoading || !rejectReason.trim()}
                  onClick={handleReject}
                >
                  {actionLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                      ></span>
                      Rejecting...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-times mr-1"></i>
                      Reject Application
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* =========================================================
   REUSABLE INFORMATION ITEM
========================================================= */

function InfoItem({ label, value, fullWidth = false }) {
  return (
    <div className={fullWidth ? "col-md-12 mb-3" : "col-md-6 mb-3"}>
      <div
        style={{
          borderBottom: "1px solid #dee2e6",
          paddingBottom: "10px",
        }}
      >
        <div
          className="text-muted"
          style={{
            fontSize: "13px",
            marginBottom: "3px",
          }}
        >
          {label}
        </div>

        <div
          style={{
            fontSize: "15px",
            fontWeight: "500",
            wordBreak: "break-word",
          }}
        >
          {value}
        </div>
      </div>
    </div>
  );
}
